export const BINA_FIRST_GROUP_NUM: number = 2;
export const BINA_SECOND_GROUP_NUM: number = 4;
export const BINA_THIRD_GROUP_NUM: number = 6;
export const BINA_FOURTH_GROUP_NUM: number = 8;
export const BINA_FIFTH_GROUP_NUM: number = 10;
export const BINA_EMPTY_GROUP: string = '00';
